import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private dynamicText = 'Please Wait';
  constructor(private spinner: NgxSpinnerService) { }
  /**
* @package LoaderService
* @instance loaderText
* @author Vikash Chaudhary
* @description get loader text
  @type getter
* @return string 
* 
*/
  get loaderText() {
    return this.dynamicText;
  }

  /**
* @package LoaderService
* @instance loaderText
* @author Vikash Chaudhary
* @description set loader text 
*  @type setter
* @param text * for showing text associated with loader 
* @return string 
* 
*/

  set loaderText(text: string) {
    this.dynamicText = text;
  }

  /**
* @package LoaderService
* @instance showSpinner
* @author Vikash Chaudhary
* @description show spinner (wait for response of api) 
* @type method  
* @return string 
* 
*/

  public showSpinner(dynamicLoadingText: string) {
    this.loaderText = dynamicLoadingText;
    setTimeout(() => {
      this.spinner.show();
    }, 50);
  }


  /**
* @package LoaderService
* @instance hideSpinner
* @author Vikash Chaudhary
* @description hide spinner
* @type method 
* @return string 
* 
*/

  public hideSpinner() {
    this.spinner.hide();
  }
}
